{
  "declineButton": "Rechazar",
  "iAgree": "Estoy de acuerdo",
  "linkTo": "Ver los Términos de Servicio",
  "title": "Condiciones de servicio"
}
